import { memo } from "react"
import { type TokenPickerViewProps } from "./types"

import useTrans from "@/hooks/useTrans"
import { LOGO_SIZES, getTokenLogoDisplay } from "@/utils/logo"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

export const View = ({
  boxProps,
  "data-testid": testId,
  handleClick,
  hasDropdown,
  token,
  emptySelectionText,
  isDisplayIcon,
}: TokenPickerViewProps) => {
  const trans = useTrans()

  return (
    <Box
      data-testid={testId}
      onClick={hasDropdown ? handleClick : () => null}
      className={`bg-secondary rounded p-2 ${hasDropdown ? "cursor-pointer" : ""}`}
      {...boxProps}
    >
      <Stack direction='row' justifyContent='space-between' alignItems='center' className='shrink-0 grow-0'>
        <Stack direction='row' alignItems='center' spacing={{ xs: 0.5, md: 1 }}>
          {token && isDisplayIcon && (
            <Box className='w-[24px]'>{getTokenLogoDisplay(token.symbol, { logo: token.icon }, LOGO_SIZES.MD)}</Box>
          )}
          <Typography
            data-testid='selected-token-symbol'
            color='inherit'
            className={`text-sm sm:text-base font-semibold ${token ? "" : "italic opacity-60"} select-none whitespace-nowrap`}
          >
            {token ? token.symbol || emptySelectionText : trans.common.token_picker_please_select}
          </Typography>
        </Stack>
        {hasDropdown && <ExpandMoreIcon color='inherit' />}
      </Stack>
    </Box>
  )
}

const memoView = memo(View)
memoView.displayName = "TokenPickerView"
export default memoView
